import { render, staticRenderFns } from "./employeemodal.vue?vue&type=template&id=bc4701f8&scoped=true"
import script from "./employeemodal.vue?vue&type=script&lang=js"
export * from "./employeemodal.vue?vue&type=script&lang=js"
import style0 from "./employeemodal.vue?vue&type=style&index=0&id=bc4701f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4701f8",
  null
  
)

export default component.exports